/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 * @author Mikhail Kokoulin
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @version 1.16.0
 * @since 1.0.0
 */

import { ReactChild } from 'react';

import styled from 'styled-components';

import { colors, notice } from '../../../../theme';

export interface INoticeProps {
    children: ReactChild;
    kind: string;
}

export const NoticeStyled = styled.div.attrs(({ kind }: { kind: string }) => ({
    className: `notice${kind ? ` notice-${kind}` : ''}`,
}))<INoticeProps>`
    display: flex;
    width: 100%;
    height: auto;
    margin: 0 auto;
    background-color: ${notice.bgColor};

    .notice__icon,
    .notice__message {
        color: ${notice.color};
    }

    .notice__icon {
        border-color: ${notice.color};
    }

    .notice__message {
        a:link,
        a:focus,
        a:visited {
            color: ${notice.color};
        }
    }

    &:not(:last-of-type) {
        box-shadow: 0 0 2px ${colors.backgroundColorWhite};
    }

    & .notice__link:after {
        content: ',';
    }

    & .notice__link:last-of-type:after {
        display: none;
    }
`;

export const NoticeIcon = styled.span.attrs({
    className: 'notice__icon',
})`
    display: inline-block;
    width: 19px;
    min-width: 19px;
    margin-right: 16px;
    height: 19px;
    line-height: 19px;
    border-radius: 50%;
    border: 1px solid;
`;

export const NoticeMessageStyled = styled.div.attrs({
    className: 'notice__message',
})`
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 24px;
    text-align: center;

    a:link,
    a:focus,
    a:visited {
        &:hover {
            text-decoration: underline;
        }
    }
`;
